
export namespace STAFF_APIS {
  export const STAFF: string = "/staff";
  export const ATTENDANCE: string = STAFF + "/attendances";
}

export namespace StaffType {
  export const FACULTY: string = "FACULTY";
  export const ADMIN: string = "ADMIN";
  export const SECURITY: string = "SECURITY";
  export const GROUND: string = "GROUND";
}
export type StaffDTO = {
  name: string;
  phone: number;
  aadhaarNumber: number | undefined;
  attendanceStatus: string;
  type: string;
};

export type StaffAbsenteesByDept = {
  type: string;
  absenteesCount: number;
};

export function getInitialStaffData(): StaffDTO {
  return {
    name: "",
    phone: undefined,
    aadhaarNumber: undefined,
    attendanceStatus: "P",
    type: undefined,
  };
}

export type StaffAttendanceDTO = {
  name: string;
  phone: number;
  attendance: string;
  type: string;
};

export function getInitialStaffAttendanceData(): StaffAttendanceDTO {
  return {
    name: "",
    phone: undefined,
    attendance: "P",
    type: undefined,
  };
}
